import { render, staticRenderFns } from "./ClaimDocsCard.vue?vue&type=template&id=2dc18bd2&scoped=true"
import script from "./ClaimDocsCard.vue?vue&type=script&lang=js"
export * from "./ClaimDocsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc18bd2",
  null
  
)

export default component.exports